import React from 'react';


function Header() {
    return (
        <h1 className='header'>To-do list manager</h1>
    )
};

export default Header;